import { withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fdb808"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-check form-check-inline mt-5"
}
const _hoisted_2 = ["id", "value", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 1,
  class: "col-lg-6 mx-auto my4"
}
const _hoisted_5 = {
  key: 0,
  class: "form-floating"
}
const _hoisted_6 = { class: "my-3 text-danger" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return ($props.answer.presentationType == $setup.AnswerPresentationType.Radio)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          ref: "radioInput",
          id: $options.getAnswerKey($props.answer),
          type: "radio",
          name: "anAnswer",
          value: $props.answer.id,
          class: "btn-check",
          checked: $options.getCheckedState(),
          onChange: _cache[0] || (_cache[0] = ($event: any) => ($options.onChanged())),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('answered')), ["enter"]))
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          class: "btn btn-question",
          for: $options.getAnswerKey($props.answer)
        }, _toDisplayString($props.answer.label), 9, _hoisted_3)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        ($props.answer.presentationType == $setup.AnswerPresentationType.Text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_currency_input, {
                ref: "crrncyInput",
                description: $props.answer.label,
                currentValue: 
              $props.answer.responseGiven
                ? $setup.formatter.formatCurrencyForInput($options.getAnsweredText())
                : ''
            ,
                elementId: $options.getAnswerKey($props.answer),
                onEntered: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('answered')))
              }, null, 8, ["description", "currentValue", "elementId"])
            ]))
          : ($props.answer.presentationType == $setup.AnswerPresentationType.DatePicker)
            ? (_openBlock(), _createBlock(_component_datepicker, {
                key: 1,
                modelValue: $setup.dateInput,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.dateInput) = $event)),
                inputFormat: "dd/MM/yyyy",
                startingView: "year",
                placeholder: "Date of Birth",
                class: "form-control"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString($setup.validationFailureMessage), 1)
        ], 512), [
          [_vShow, $setup.flagInvalidAnswer]
        ])
      ]))
}